import React from 'react';

import { Icon } from '@chakra-ui/react';

export const ManagedIdentityIcon = props => (
  <Icon viewBox="0 0 720 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-280 0)">
      <g>
        <path
          d="M790 630 790 570C790 503.727 736.273 450 670 450L430 450C363.726 450 310 503.727 310 570L310 630"
          stroke="currentColor"
          strokeWidth="60"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M670 210C670 276.274 616.274 330 550 330 483.726 330 430 276.274 430 210 430 143.726 483.726 90 550 90 616.274 90 670 143.726 670 210Z"
          stroke="currentColor"
          strokeWidth="60"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M790 330 970 330"
          stroke="currentColor"
          strokeWidth="60"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M880 240 880 420"
          stroke="currentColor"
          strokeWidth="60"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          fill="none"
          fillRule="nonzero"
        />
      </g>
    </g>
  </Icon>
);
